import React, { Component } from 'react';
import PropTypes from 'prop-types';

import ErrorScreen from '../../common/ErrorScreen/ErrorScreen';
import TimesHeader from './TimesHeader';
import BtnTimes from './BtnTimes';

import { StyledTableTimes } from './styles/StyledTableTimes';

class TableTimes extends Component {
  constructor(props) {
    super(props);

    this.showTimes = this.showTimes.bind(this);
  }

  showTimes(from, to) {
    const { data, onClickRow } = this.props;
    let ret = [];
  
    for (from; from < to; from++) {
      ret.push(
          <BtnTimes
            key={'intervals-times' + from}
            data={data[from]}
            onClickRow={onClickRow}
          />
      )
    }
    return ret;
  }

  render() {
    const { header1, header2, data } = this.props;

    if (data.length < 1) {
      return (
        <StyledTableTimes>
          <div className="table-times-error">
            <ErrorScreen 
              title="Nejsou dostupné žádné termíny pro tento den."
            />
          </div>
        </StyledTableTimes>
      );
    }

    const edge = Math.ceil(data.length / 2);

    const times1 = this.showTimes(0, edge);
    const times2 = this.showTimes(edge, data.length);

    return (
      <StyledTableTimes>
        <div className="row">

          <div className="col col-lg-6 col-md-12">
            <TimesHeader
              header1={header1}
              header2={header2}
            />
            <ul>
              { times1 }
            </ul>
          </div >

          <div className="col col-lg-6 col-md-12">
            <div className="interbals-table-header-disable-medium">
            <TimesHeader 
              header1={header1}
              header2={header2}
            />
            </div>
            <ul>
              { times2 }
            </ul>
          </div >

        </div>
      </StyledTableTimes>
    );
  }
}


TableTimes.propTypes = {
  header1: PropTypes.string.isRequired,
  header2: PropTypes.string.isRequired,
  data: PropTypes.array.isRequired,
  onClickRow: PropTypes.func.isRequired,
};


export default TableTimes;



// WEBPACK FOOTER //
// ./src/components/IntervalsContent/TableTimes.js